<template>
    <Modal v-show="visible" v-on:close="closeModal" :confirmText="'Unban'" :title="'Unban'">
        <template v-slot:body>
            <div class="input-group checkbox">
                <input v-model="unbanFromDatabase" type="checkbox" id="unbanFromDatabase"
                       :disabled="unbanDeleteFromDatabase">
                <label for="unbanFromDatabase">Unban</label>
            </div>
            <div class="input-group checkbox">
                <input v-model="unbanDeleteFromDatabase" type="checkbox" id="unbanDeleteFromDatabase"
                       :disabled="unbanFromDatabase">
                <label for="unbanDeleteFromDatabase">Unban & slet fra databasen</label>
            </div>
            <div class="input-group checkbox" v-if="$api.getUser().hasPermission(['bansite.unban.*','bansite.unban.fvforum'])">
                <input v-model="unbanAsFvForum" type="checkbox" id="unbanAsFvForum">
                <label for="unbanAsFvForum">Gør overstående som FvForum</label>
            </div>
        </template>
        <template v-slot:footer>
            <button
                    type="button"
                    class="btn btn-primary"
                    @click="confirmModal"
                    :disabled="!(unbanFromDatabase || unbanDeleteFromDatabase)">
                Unban Spiller
            </button>
            <button
                    type="button"
                    class="btn btn-cancel"
                    @click="closeModal">
                Annuller
            </button>
        </template>
    </Modal>
</template>

<script>
    import Modal from './Modal'

    export default {
        components: {
            Modal
        },
        data() {
            return {
                unbanFromDatabase: false,
                unbanDeleteFromDatabase: false,
                unbanAsFvForum: false
            }
        },
        methods: {
            data() {
                return {
                    unbanFromDatabase: this.unbanFromDatabase,
                    unbanDeleteFromDatabase: this.unbanDeleteFromDatabase,
                    unbanAsFvForum: this.unbanAsFvForum
                }
            },
            closeModal() {
                this.$emit('close');
                this.unbanFromDatabase = false;
                this.unbanDeleteFromDatabase = false;
                this.unbanAsFvForum = false;

            },
            confirmModal() {
                this.$emit('confirm', this.data())
                this.unbanFromDatabase = false;
                this.unbanDeleteFromDatabase = false;
                this.unbanAsFvForum = false;
            }
        },
        props: ['visible', 'punishment'],
    }
</script>

<style scoped lang="scss">
</style>